import { ref } from 'vue'
import { message } from 'ant-design-vue'
import type { SelectProps } from 'ant-design-vue'
import dayjs from 'dayjs'
import CryptoJS from 'crypto-js'
import serviceSttus from '@jms/api/status'
import axios, { AxiosError } from 'axios'
import { RouteLocationNormalized } from 'vue-router'
import { useSettingStore } from '@jms/store/sysSetting'
import HTTP_CODE_STATUS from './httpCode'
import { JtsCode } from './enums'
import { useApi } from '@xinghai/site-common'
import { dictService, GlobalService } from '@jms/api/api'
import { translateCollector } from './translateCollector'

// 获取快递公司
export const companyList = async () => {
  const value_list = useApi(GlobalService.expressList)
  const options1 = ref<SelectProps['options']>([])
  const result = await value_list.fetchData({})
  options1.value = result.data
  return options1.value
}

const { VITE_APP_ASDFGHJKL } = import.meta.env
//跳转至登录页
export function reLogin() {
  const base = import.meta.env.BASE_URL || '/'
  const loginPath = `${base}login`.replace(/\/\//g, '/')
  location.pathname !== loginPath && location.replace(loginPath)
}
//服务器正常响应数据接口错误处理
export function requestFail(data: any) {
  message.error(data?.msg ?? lang(JtsCode[data?.code]) ?? lang('未知错误'))
  if (HTTP_CODE_STATUS.INVALID.includes(Number(data?.code))) reLogin()
}
//服务器错误处理
export function requestError(err: AxiosError) {
  const { response } = err
  let msg = lang('网络错误！请检查网络！')
  if (err.message.indexOf('timeout') !== -1) {
    msg = lang('请求超时')
  }
  if (response) {
    msg = response.status in serviceSttus ? response?.data?.msg || serviceSttus[response.status] : lang('未知错误')
  }
  message.error(msg)
  if (HTTP_CODE_STATUS.INVALID.includes(Number(response?.status))) reLogin()
}

export function hasProp(obj: any, prop: string): boolean {
  return Object.prototype.hasOwnProperty.call(obj, prop)
}

export const objectToString = Object.prototype.toString
export const toTypeString = (value: any) => objectToString.call(value)
export const hasOwnProperty = Object.prototype.hasOwnProperty
export const hasOwn = (val: any, key: any) => hasOwnProperty.call(val, key)
export const isArray = Array.isArray
export const isNumber = (val: any) => toTypeString(val) === '[object Number]'
export const isMap = (val: any) => toTypeString(val) === '[object Map]'
export const isSet = (val: any) => toTypeString(val) === '[object Set]'
export const isDate = (val: any) => toTypeString(val) === '[object Date]'
export const isFunction = (val: any) => typeof val === 'function'
export const isString = (val: any) => typeof val === 'string'
export const isSymbol = (val: any) => typeof val === 'symbol'
export const isObject = (val: any) => val !== null && typeof val === 'object'
export const isPromise = (val: any) => {
  return isObject(val) && isFunction(val.then) && isFunction(val.catch)
}

/**
 * 枚举值转select options
 * @param enumVal 枚举数据
 * @param hasAll 是否返回全部选项
 * @returns options
 */
export const getOptionsByEntry = (enumObj: any, hasAll = false): any => {
  const options = Object.entries(enumObj).map((_: any) => ({ label: lang(_[1]), value: _[0] }))
  if (hasAll) options.unshift({ label: lang('全部'), value: '' })
  return options
}

/**
 * 根据枚举对象值获取键
 * @param enumObj 枚举对象
 * @param enumValue 枚举值
 * @returns string
 */
export function getEnumKeyByEnumValue<TEnumKey extends string, TEnumVal extends string | number>(
  enumObj: { [key in TEnumKey]: TEnumVal },
  enumValue: TEnumVal
): string {
  return (Object.keys(enumObj) as TEnumKey[]).find((x) => enumObj[x] === enumValue) ?? ''
}

/**
 * 显示银行卡卡号
 * @param num 银行卡号码
 * @param type 显示后四位或全部 1 不加密 2 加密
 */

export const getCardNum = (num: string | undefined, type: 1 | 2 = 1) => {
  return type === 2 ? '****' + (num || '').slice(-4) : num
}
/**
 * 手机号脱敏第5-8位包含60
 * @param str 手机号
 * @returns string
 */
export const encryptPhone = (str: string) => {
  const strArr = str.split('')
  strArr.splice(4, 4, '****')
  return strArr.join('')
}
/**
 * 加载json文件
 * @returns
 */

export const loadAreaJson = () => {
  return new Promise((resolve, reject) => {
    axios.get('https://yl-pufile.jtexpress.my/jmsmy-pudo/address_json.json').then((res) => {
      if (res.status === 200) {
        resolve(res.data)
      }
    })
  })
}

export function formatDate(val?: number, format = 'YYYY-MM-DD HH:mm:ss') {
  return val ? dayjs(val).format(format) : dayjs().format(format)
}

export function isSuccess(res: any) {
  const SpecialCodes = [
    HTTP_CODE_STATUS.SUCCESS,
    HTTP_CODE_STATUS.JTS_UPLOAD_SUCCESS,
    HTTP_CODE_STATUS.TIME_BACK_STATUS,
    HTTP_CODE_STATUS.JTS_SUCCESS
  ]
  return res?.code && SpecialCodes.includes(res.code)
}
interface IOptions {
  text: string
  value: any
}
export function array2Map(array: IOptions[]) {
  const map: Record<string, string> = {}
  if (Array.isArray(array)) {
    array.forEach((item) => (map[item.value] = item.text))
  }
  return map
}
export function getUUID(len = 32, _radix?: number) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  const radix = _radix || chars.length
  if (len) {
    for (let i = 0; i < len; i++) {
      uuid[i] = chars[0 | (Math.random() * radix)]
    }
  } else {
    let r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (let i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}
/**
 * 动态化meta属性
 * */
export function restructureMeta(to: RouteLocationNormalized) {
  const arr = ['/servicePointAuth/Check']
  const { meta, path, query } = to
  if (arr.includes(path)) {
    return {
      ...meta,
      title: meta.title + '-' + query.serviceSiteCode
    }
  }
  return meta
}

/**获取站点编号数组 */
export function getSiteCodes(val: any): Array<string | number> {
  return !val ? [] : val.split(/[\n,，\s]/g).filter((_: string | number) => _)
}

/**
 * 省市区扁平数组转树
 * @param items 省市区扁平数组
 * @returns 省市区tree
 */
export function arrayToTree(items: Record<string, any>[]) {
  const result = []
  const itemMap: Record<string, any> = {}
  for (const item of items) {
    const id = item.areaId
    const pid = item.parentId

    if (!itemMap[id]) {
      itemMap[id] = {
        children: []
      }
    }
    itemMap[id] = {
      ...item,
      children: itemMap[id]['children']
    }
    const treeItem = itemMap[id]
    if (pid == 0) {
      result.push(treeItem)
    } else {
      if (!itemMap[pid]) {
        itemMap[pid] = {
          children: []
        }
      }
      itemMap[pid].children.push(treeItem)
    }
  }
  return result
}
interface TreeNode {
  areaId: string | number // 节点唯一ID
  parentId: string | number // 父节点ID
  children?: TreeNode[] // 子节点（可选）
  [key: string]: any // 其他扩展字段
}
/**
 * 扁平数组转换为树形结构
 * @param items 扁平节点数组（必须包含areaId/parentId字段）
 * @param rootPid 根节点的parentId值（默认0）
 * @returns 树形结构数组
 */
export function arrayToTreeIdn(flatList: TreeNode[], rootId: string | number = 0): TreeNode[] {
  // 1. 创建节点映射表，方便快速查找父节点
  const nodeMap = new Map()
  flatList.forEach((item) => {
    nodeMap.set(item.id.toString(), { ...item, children: [] })
  })
  // 2. 构建三级树形结构
  const tree: TreeNode[] = []
  flatList.forEach((item) => {
    const currentNode = nodeMap.get(item.id.toString())
    const parentIdStr = item.parentId.toString()

    // 一级节点（parentId为rootId）
    if (parentIdStr === rootId.toString()) {
      tree.push(currentNode)
    }
    // 二级/三级节点：找到父节点并挂载
    else {
      const parentNode = nodeMap.get(parentIdStr)
      if (parentNode) {
        parentNode.children.push(currentNode)
      }
    }
  })

  return tree
}

// 国际化过滤器
export function lang(str: string) {
  const settingStore = useSettingStore()
  const label = settingStore.langJson?.[str]

  // 收集翻译key（仅开发环境） && 非中文环境
  if (process.env.NODE_ENV !== 'production' && settingStore.locale !== 'zh') {
    const hasChinese = /[\u4e00-\u9fa5]/.test(str)
    translateCollector.collect(str, hasChinese && !label ? 1 : 2)
  }

  return label || str || ''
}

/**aes加密 */
export function aesEncrypt(content: string) {
  const key = CryptoJS.enc.Utf8.parse(VITE_APP_ASDFGHJKL)
  const srcs = CryptoJS.enc.Utf8.parse(content)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}
/**aes解密 */
export function aesDecrypt(content: string) {
  const key = CryptoJS.enc.Utf8.parse(VITE_APP_ASDFGHJKL)
  const decrypted = CryptoJS.AES.decrypt(content, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(decrypted)
}
/**排序的函数 */
export function objKeySort(data: any) {
  const obj = {} as any
  Object.keys(data)
    .sort()
    .forEach(function (item) {
      if (typeof data[item] !== 'object') {
        obj[item] = data[item]
      } else if (toString.call(data[item]) === '[object Array]') {
        obj[item] = []
        data[item].forEach((i: object, k: number) => {
          if (typeof i === 'object') {
            obj[item][k] = objKeySort(i)
          } else {
            obj[item][k] = i
          }
        })
      } else if (data[item] !== null && typeof data[item] === 'object') {
        obj[item] = objKeySort(data[item])
      }
    })
  return obj
}

/**删除数组属性为空 */
export function deleteNullKey(obj: any) {
  Object.keys(obj).forEach((item) => {
    if (obj[item] === null) {
      delete obj[item]
    } else if (toString.call(obj[item]) === '[object Array]') {
      obj[item].forEach((i: object, k: number) => {
        obj[item][k] = deleteNullKey(i)
      })
    } else if (obj[item] !== null && typeof obj[item] === 'object') {
      obj[item] = deleteNullKey(obj[item])
    }
  })
  return obj
}
export function makeMap(arr: Record<string, any>, value: string) {
  if (!value) return false
  return arr.find((item: Record<string, any>) => item.value === value).label
}
/** 过滤枚举字段 */
export function formatData(data: Record<string, any>, keyArr: string[]) {
  if (data === null) return false
  const _data = data
  Object.keys(data).forEach((item: string) => {
    if (keyArr.includes(item) && data[item] !== null && Object.prototype.hasOwnProperty.call(data[item], 'id')) {
      _data[item] = data[item].id
    } else if (toString.call(data[item]) === '[object Array]') {
      data[item].forEach((i: Record<string, any>, k: number) => {
        _data[item][k] = formatData(i, keyArr)
      })
    } else if (data[item] !== null && typeof data[item] === 'object') {
      _data[item] = formatData(data[item], keyArr)
    }
  })
  return _data
}
export function validatenull(val: any) {
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }
  if (val instanceof Array) {
    if (val.length === 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') {
      return true
    }
    return false
  }
  return false
}

/**修改刷新事件提示语 */
export const loadText = (e: any) => {
  // 不是所有浏览器都支持提示信息的修改
  const confirmationMessage =
    '您所查找的网页要输入已输入的信息，\n' + '返回此页面可能需要重复已进行的所有操作。是否要继续操作'
  e.returnValue = confirmationMessage
  return confirmationMessage
}

type PixelBitItem = {
  binTypes: string
  pixelBitBinType: {
    [key: string]: string
  }
}

type InputItem = {
  binNum: number
  pixelBitItems: PixelBitItem[]
}
// const apidata = [
//   {
//     binNum: 48,
//     pixelBitItems: [
//       {
//         binTypes: 'S,M,L,F',
//         pixelBitBinType: {
//           S: '1',
//           M: '1.7719',
//           L: '2.3684',
//           F: '3.1228'
//         }
//       }
//     ]
//   }
// ]
// const obj = {
//   48: {
//     'S,M,L,F': {
//       S: 1,
//       M: 1.7719,
//       L: 2.3684,
//       F: 3.1228
//     },
//     'S,M,L': {
//       S: 1,
//       M: 1.7719,
//       L: 2.3684,
//       F: 3.1228
//     }
//   }
// }
// 这里将上面的数据apidata转换成下面的obj格式
export const transformData = (input: InputItem[]): Record<number, Record<string, Record<string, string>>> => {
  const result: Record<number, Record<string, Record<string, string>>> = {}
  input.forEach((item: InputItem) => {
    const { binNum, pixelBitItems } = item
    result[binNum] = {} // 确保存在这个 key
    pixelBitItems.forEach((pixelItem: PixelBitItem) => {
      result[binNum][pixelItem.binTypes] = pixelItem.pixelBitBinType
    })
  })
  return result
}
// 比较版本号 v1是大版本 v2是小版本
export const isNewer = (v1: string, v2: string) => {
  // 去掉前面的 V 或 v
  v1 = v1.replace(/^v/i, '')
  v2 = v2.replace(/^v/i, '')
  // 拆成数字数组
  const arr1 = v1.split('.').map(Number)
  const arr2 = v2.split('.').map(Number)
  // 对齐长度，短的补 0
  const maxLen = Math.max(arr1.length, arr2.length)
  while (arr1.length < maxLen) arr1.push(0)
  while (arr2.length < maxLen) arr2.push(0)
  // 挨个比较
  for (let i = 0; i < maxLen; i++) {
    if (arr1[i] > arr2[i]) return true // v1 更新
    if (arr1[i] < arr2[i]) return false // v1 旧
  }
  return false // 完全相等则返回 false（不算更新）
}

/**
 * 获取下一个柜号
 * @param {string | undefined | null} current 当前柜号
 * @returns {string} 下一个柜号
 */
export function getNextCabinetNo(current?: string | null) {
  // 没有柜号，初始化为 A
  if (!current) return 'A'
  const arr = current.split('')
  let i = arr.length - 1
  while (i >= 0) {
    if (arr[i] !== 'Z') {
      arr[i] = String.fromCharCode(arr[i].charCodeAt(0) + 1)
      return arr.join('')
    }
    arr[i] = 'A'
    i--
  }
  // 全是 Z（如 Z / ZZ / ZZZ）
  return 'A' + arr.join('')
}

export * from './keys'

/** 开启表格拖动列并对该列宽度赋值 */
export function changeResizeColumn(w: any, col: { width: any }) {
  col.width = w
}
